export default __webpack_public_path__ + "static/media/MillingCutsImg.d7db1ef7.jpg";